import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BodyClassSetter from '../Elements/BodyClassSetter';
import Splash from '../Elements/Splash';
import Header from '../Elements/Header';
import AllClubsView from '../Elements/AllClubsView';
import Footer from '../Elements/Footer';
import { useViewStore, useSplashStore } from '../store';

const AllClubsShareView = () => {
    const history = useHistory();
    const setView = useViewStore((state) => state.setView);
    const [shouldShowSplash, setShouldShowSplash] = useState(!history.location.search);
    const { hasBeenSplashed, setHasBeenSplashed } = useSplashStore((state) => ({
        hasBeenSplashed: state.hasBeenSplashed,
        setHasBeenSplashed: state.setHasBeenSplashed,
    }));

    useEffect(() => {
        setView('OverviewView');

        if (shouldShowSplash) {
            const splashTimeout = setTimeout(() => {
                setShouldShowSplash(false);
                setHasBeenSplashed(true); 
            }, 3000);
            return () => clearTimeout(splashTimeout);
        }
    }, [setView, shouldShowSplash, setHasBeenSplashed, hasBeenSplashed]);

    return (
        <BodyClassSetter>
            {shouldShowSplash && !hasBeenSplashed ? <Splash /> :
                <>
                    <Header title="P&I Market Review 2024" />
                    <AllClubsView />
                    <Footer />
                </>
            }
        </BodyClassSetter>
    );
};

export default AllClubsShareView;
